export var REQUEST_TIMEOUT = 20000;
export var ZIPCODE_LENGTH = 5;
export var ADDRESSES_PAGE_SIZE = 21;
export var ADDRESSES_LIMIT_B2C = 50;
export var ADDRESSES_LIMIT_B2B = 500;
export var PAYMENTS_PAGE_SIZE = 21;
